module.exports = __webpack_public_path__ + "static/media/thumb-down.1079d403.svg";